import React from "react"

export default ({props}) => {
	return (
		<iframe title="video" width="100%" height="300" src={`https://www.youtube-nocookie.com/embed/${props.field_youtube.split("watch?v=")[1]}`} frameBorder="0" allow="autoplay; encrypted-media; picture-in-picture;" allowFullScreen></iframe>
	)
}
